import Store from 'store/store';

Store.on('TOGGLE_NEWSLETTER_BANNER', (closed) => {
	let store = Store.get();
	if (typeof closed === 'undefined') {
		closed = store.signupBanner?.open;
	}
	let newState = { open: !closed };
	if (!store.signupBanner) {
		store.set({ signupBanner: newState });
	} else {
		store.signupBanner.set(newState);
	}
});
